import React, { useEffect, useState } from 'react';
import { CONFIG } from "../config"; // Ensure CONFIG has API_BASE_URL and TRUCK_HEALTH_OVERVIEW_URL
import { Link } from 'react-router-dom';
import CustomDropdown from './CustomDropdown';

const TruckHealthOverview = ({ selectedDate }) => {

  const statuses = ['Healthy', 'At Risk', 'Down'];
  const [selectedStatus, setSelectedStatus] = useState('');

  const makes = ['Peterbilt', 'Mack', 'Heil', 'Freightliner', 'Kenworth', 'Hino'];
  const [selectedMake, setSelectedMake] = useState('');

  const models = ['579', '310'];
  const [selectedModel, setSelectedModel] = useState('');

  const issues = ['Battery', 'Oil'];
  const [selectedIssue, setSelectedIssue] = useState('');

  const [loading, setLoading] = useState(false);
  const [trucks, setTrucks] = useState([]);
  const [error, setError] = useState(null);

  // Fetch truck health data whenever the selectedDate changes.
  useEffect(() => {
    if (!selectedDate) return; // wait until selectedDate is available

    const fetchTruckData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${CONFIG.API_BASE_URL}/${CONFIG.TRUCK_HEALTH_OVERVIEW_URL}/${localStorage.getItem(
            "tensor-user-id"
          )}?date_str=${selectedDate}`,
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("tensor-auth-token"),
            },
          }
        );
        const data = await response.json();
        // The sample response structure: { success:true, message:"Truck Health Overview", data:[{...}, {...}] }
        if (data.success && Array.isArray(data.data)) {
          setTrucks(data.data);
          console.dir(data.data);
          setError(null);
        } else {
          setTrucks([]);
          setError("No truck data available.");
        }
      } catch (err) {
        console.error("Failed to fetch truck data:", err);
        setError("Failed to fetch truck data.");
        setTrucks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTruckData();
  }, [selectedDate]);


  // const truckData = [
  //   {
  //     id: 7104, make: "Peterbilt", model: 579, status: "Healthy", age: 4,
  //     miles: 4309, lastMaint: 45, downtime: 0, maintComp: 100, inspComp: 96,
  //   },
  //   {
  //     id: 7131, make: "Mack", model: 310, status: "Down", age: 12,
  //     miles: 9735, lastMaint: 120, downtime: 6, maintComp: 87, inspComp: 78,
  //   },
  //   {
  //     id: 7003, make: "Peterbilt", model: 579, status: "At risk", age: 3,
  //     miles: 3077, lastMaint: 120, downtime: 4, maintComp: 90, inspComp: 91,
  //   },
  //   // Add more rows as needed...
  // ];



const getComplianceColor = (value) => {
  // Remove % if it's a string like "95%"
  const numericValue = typeof value === "string" ? parseFloat(value.replace("%", "")) : value;

  if (numericValue >= 95) return "text-green-600";
  if (numericValue >= 90) return "table_warning_bg_color";
  return "text-red-600";
};

const getAgeColor = (value) => {

  if (value <= 5) return "text-green-600  font-normal";
  //if (value > 5 && value <= 9) return "text-yellow-500 font-semibold";
  if (value > 5 && value <= 9) return "table_warning_bg_color font-semibold";  
  return "text-red-600 font-bold";
};

const getMaintenanceColor = (value) => {
  if (value > 90) return "text-red-600 font-bold";  
  return "text-green-600 font-normal";
};

const getDowntimeNextWeekColor = (value) => {

  if (value > 0) return "text-red-600 font-bold";  
  return "text-green-600 font-normal";
};

  return (




    <section className="pt-2">

      {loading && (
        <div class="text-center">
          <div class="flex justify-center mb-4">
            <svg class="w-6 h-6 text-blue-500 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
              <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z">
              </path>
            </svg>
          </div>
        </div>
      )}

      {!loading && (
        <div>
          <h2 className="text-xl font-semibold mb-4 text-2xl font-bold truck_page_head_text">Truck Health Overview</h2>
          <div className="flex gap-4 flex-wrap mb-6">
            <CustomDropdown
              label="Filter by status"
              options={statuses}
              selected={selectedStatus}
              setSelected={setSelectedStatus}
            />

            <CustomDropdown
              label="Filter by make"
              options={makes}
              selected={selectedMake}
              setSelected={setSelectedMake}
            />

            <CustomDropdown
              label="Filter by model"
              options={models}
              selected={selectedModel}
              setSelected={setSelectedModel}
            />

            <CustomDropdown
              label="Filter by issue"
              options={issues}
              selected={selectedIssue}
              setSelected={setSelectedIssue}
            />
          </div>

          {/* Table Wrapper for Scroll */}
          <div className="overflow-x-auto bg-white shadow-sm truck_table_border p-4">
            <div className="">
              <table className="min-w-full text-sm text-left truck_table_bg">
                <thead className="text-gray-700">
                  <tr>
                    <th className="px-4 truck_table_col">Vehicle ID</th>
                    <th className="px-4 truck_table_col">Make</th>
                    <th className="px-4 truck_table_col">Model</th>
                    <th className="px-4 truck_table_col">Commissioned On</th>
                    <th className="px-4 truck_table_col">Status</th>
                    <th className="px-4 truck_table_col">Age (yrs)</th>
                    <th className="px-4 truck_table_col">Miles</th>
                    <th className="px-4 truck_table_col">Last maintenance (days ago)</th>
                    <th className="px-4 truck_table_col">Downtime next week (days)</th>
                    <th className="px-4 truck_table_col">Maintenance compliance</th>
                    <th className="px-4 truck_table_col">Inspection compliance</th>
                    <th className="px-4 truck_table_col">DVIR compliance</th>
                    <th className="px-4 truck_table_col">Avg. Cost <br />per Mile ($)</th>
                    <th className="px-4 truck_table_col">Monthly maintenance Cost ($)</th>
                    <th className="px-4 truck_table_col">Top issue</th>
                  </tr>
                </thead>
                <tbody>
                  {trucks.map((truck) => (
                    <tr key={truck.id} className="hover:bg-gray-50 border-2 border-gray-200">
                      <td className="px-4 py-4 text-blue-600 font-medium hover:underline cursor-pointer">
                        <Link 
                          to={`/vehicle/${truck.vehicle_id}`} 
                          className="text-blue-600 hover:underline cursor-pointer underline"
                        >
                          {truck.vehicle_id}
                        </Link>
                      </td>
                      <td className="px-4 py-2 table_cells_text t_text_color">{truck.make}</td>
                      <td className="px-4 py-2 table_cells_text t_text_color">{truck.model}</td>
                      <td className="px-4 py-2 table_cells_text t_text_color">{truck.commissioned_date}</td>
                      <td className={`px-4 py-2 font-medium ${
                                truck.status.toLowerCase() === "healthy"
                                  ? "text-green-600"
                                  : truck.status.toLowerCase() === "at risk"
                                  ? "table_warning_bg_color"
                                  : "text-red-600"
                              }`}>
                              {truck.status.toLowerCase() === "healthy" ? (
                                <span>
                                  <i className="ti ti-circle-check" />
                                </span>
                              ) : truck.status.toLowerCase() === "at risk" ? (
                                <span>
                                  <i className="ti ti-alert-triangle" />
                                </span>
                              ) : (
                                <span>
                                  <i className="ti ti-circle-x" />
                                </span>
                              )}
                        <span className="font-semibold">&nbsp;{truck.status}</span>
                      </td>
                      <td className={`px-4 py-2 table_cells_text_normal ${getAgeColor(truck.age)}`}>
                        {truck.age}
                      </td>
                      <td className="px-4 py-2 table_cells_text t_text_color">
                      {truck?.mileage != null ? `${new Intl.NumberFormat().format(truck.mileage)}` : 'NA'}
                      </td>
                      <td className={`px-4 py-2 table_cells_text_normal ${getMaintenanceColor(truck.last_maintenance_days_ago)}`}>
                        {truck.last_maintenance_days_ago}
                      </td>
                      <td className={`px-4 py-2 table_cells_text_normal ${getDowntimeNextWeekColor(truck.downtime_next_week_days)}`}>
                        {truck.downtime_next_week_days}
                      </td>

                      <td className={`px-4 py-2 table_cells_text_normal font-medium ${getComplianceColor(truck.maintenance_compliance)} font-semibold`}>
                        {parseFloat(truck.maintenance_compliance.replace('%', '')) >= 95 ? (
                          <span>
                            <i className="ti ti-circle-check" />
                          </span>
                        ) : parseFloat(truck.maintenance_compliance.replace('%', '')) >= 90 ? (
                          <span>
                            <i className="ti ti-alert-triangle" />
                          </span>
                        ) : (
                          <span>
                            <i className="ti ti-circle-x" />
                          </span>
                        )}
                        &nbsp;{truck.maintenance_compliance}
                      </td>

                      <td className={`px-4 py-2 table_cells_text_normal ${getComplianceColor(truck.inspection_compliance)} font-semibold`}>
                        {parseFloat(truck.inspection_compliance.replace('%', '')) >= 95 ? (
                          <span>
                            <i className="ti ti-circle-check" />
                          </span>
                        ) : parseFloat(truck.inspection_compliance.replace('%', '')) >= 90 ? (
                          <span>
                            <i className="ti ti-alert-triangle" />
                          </span>
                        ) : (
                          <span>
                            <i className="ti ti-circle-x" />
                          </span>
                        )}
                        &nbsp;{truck.inspection_compliance}
                      </td>

                      <td className={`px-4 py-2 table_cells_text_normal ${getComplianceColor(truck.dvir_compliance)} font-semibold`}>
                        {parseFloat(truck.dvir_compliance.replace('%', '')) >= 95 ? (
                          <span>
                            <i className="ti ti-circle-check" />
                          </span>
                        ) : parseFloat(truck.dvir_compliance.replace('%', '')) >= 90 ? (
                          <span>
                            <i className="ti ti-alert-triangle" />
                          </span>
                        ) : (
                          <span>
                            <i className="ti ti-circle-x" />
                          </span>
                        )}
                        &nbsp;{truck.dvir_compliance}
                      </td>

                      <td className={`px-4 py-2 table_cells_text t_text_color`}>
                        {truck.avg_cost_per_mile}
                      </td>
                      <td className={`px-4 py-2 table_cells_text t_text_color`}>
                        {truck?.monthly_maintenance_cost != null ? `${new Intl.NumberFormat().format(truck.monthly_maintenance_cost)}` : 'NA'}
                      </td>
                      <td className={`px-4 py-2 table_cells_text t_text_color`}>
                        {truck.top_issue}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default TruckHealthOverview;
